import { NgModule } from '@angular/core';
import { ThaiPhonePipe } from './thai-phone-number.pipe';
import { SanitizerHtmlPipe } from './sanitizer-html.pipe';

@NgModule({
  declarations: [ThaiPhonePipe, SanitizerHtmlPipe],
  exports: [ThaiPhonePipe, SanitizerHtmlPipe],
})
export class CustomPipeModule {}
